export const createStaticReducer = <T>() => {
  return (state: T = {} as T): T => state;
};
